
import Vue from 'vue';
import Component, { mixins } from 'vue-class-component';
import googleLoginService from '@/app/services/google-login-service';
import GTMService from '@/app/services/google-tag-manager-service';
import { AuthService } from '@/app/services/auth-service';
import WorkspaceUtils from '@/app/utils/workspace-utils';
import { ToastType } from '@/lib/components/toast/types';
import logger from '@/app/logger';
import TubeError from '../../../lib/tube-error';
import message from '../../locales/en/message';
import apiClient from '@/app/clients/api-client';
import TubeLabel from '@/lib/form/label/Label.vue';
import TInput from '@/lib/form/input/Input.vue';
import TButton from '@/lib/form/button/Button.vue';
import Loader from '@/app/components/loaders/Loader.vue';
import BlockedDomains from '@/lib/blocked-domains.json';
import SignupTestimonial from '@/app/components/sign-up/SignupTestimonial.vue';
import TCheckbox from '@/lib/form/checkbox/Checkbox.vue';

@Component({
  name: 'google_sign_up',
  props: ['mode', 'context'],
  components: {
    TubeLabel,
    TInput,
    TButton,
    Loader,
    SignupTestimonial,
    TCheckbox
  },
})
export default class GoogleSignUpComponent extends Vue {
  private isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  private gaLoaded = false;
  private id = 'google-sign-up';
  private gaLoader = false;
  private googleToken!: string;
  private invalidEmail = false;
  private errorMessage = '';
  private genericLoader = false;
  private email = '';
  private isAgreed = false;
  private agreementError = ''

  get nextStepCTA() {
    return this.$t('onboard.register.email_sign_up.continue_with_email');
  }

  get isReferral() {
    const query = this.$route.query;
    const storedValue = window.localStorage.getItem('r');

    if ((query.ucc && query.productId) || storedValue) {
      return true
    }
  }

  keyup() {
    this.invalidEmail = false;
    this.errorMessage = '';
  }

  mounted() {
    googleLoginService
      .load()
      .then(() => {
        if (!this.showLoginButton()) {
          window.location.href = WorkspaceUtils.getCommonUrl();
        } else {
          this.gaLoaded = true;
        }
      })
      .catch((error) => {
        this.gaLoaded = true;
        if (error.error == 'idpiframe_initialization_failed') {
          this.$show({
            type: ToastType.Danger,
            message: this.$t('message.error.incognito_login'),
            dismissible: true,
          });
        } else if (error.error == 'google_script_not_loaded') {
          this.$show({
            type: ToastType.Danger,
            message: error.message,
            dismissible: true,
          });
          this.$trackError(error);
        } else {
          this.$error(error);
        }
      });

    GTMService.load();
    GTMService.trackPageView();
    this.attributeReferrer(this.$route.query)
  }

  next() {
    if (this.validateEmail() || this.validateDomain()) {
      this.invalidEmail = true;
      this.errorMessage = "Please enter a valid business email. We don't spam.";
      return;
    }
    if( !this.isAgreed){
      this.agreementError = "Please read and accept the Terms and Privacy Policy"
      return ;
    }
    this.genericLoader = true;
    return apiClient
      .verifyUser(this.email, true)
      .then((result) => {
        this.genericLoader = false;
        if (result.exists && result.has_owned_workspaces) {
          this.$success(this.$t('onboard.register.user_exists'));
          const emailHash =
            '#' +
            btoa(
              JSON.stringify({
                email: this.email,
                skipVerify: true,
              })
            );
          this.$router.push({
            name: 'common_login',
            hash: emailHash,
          });
        } else {
          this.genericLoader = true;
          return apiClient.sendOTP(this.email).then((data) => {
            this.genericLoader = false;
            this.$emit('update', {
              flowType: 'verify_otp',
              data: { email: this.email, targetFlow: 'set_password' },
            });
          });
        }
      })
      .catch((error) => {
        this.genericLoader = false;
        this.$error(error);
      });
  }

  attributeReferrer(query) {
    const ucc = query.ucc
    const productId = query.productId
    if (ucc && productId) {
      this.storeValue("r", `${ucc};${productId}`)
    }
  }

  storeValue(key, value) {
    if (this.isSafari) {
      window.sessionStorage.setItem(key, value);
    } else {
      window.localStorage.setItem(key, value);
    }
  }

  validateDomain() {
    return BlockedDomains.includes(this.email.split('@')[1]);
  }
  validateEmail() {
    if (
      !/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/i.test(
        this.email
      )
    ) {
      return `wrong format`;
    }
  }

  showLoginButton() {
    return !AuthService.getInstance().isLoggedIn;
  }

  updateAgreement(checked,value) {

    this.isAgreed = checked;
  }
}
